/**
 * Created by Administrador on 29/11/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('fareSsrService', fareSsrService)

    fareSsrService.$inject = ['$http', 'CONFIG', 'messageService'];

    function fareSsrService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/ssrs';
        var service = {
            getFareItems: getFareItems,
            getFareSsrList: getFareSsrList,
            getFareItem: getFareItem,
            getFareSsrByItemId: getFareSsrByItemId,
            saveFareItem: saveFareItem,
            updateFareItem: updateFareItem,
            deleteFareItem: deleteFareItem
        }

        return service;

        function getFareItems(page, size){
            return $http.get(urlBase + '?page=' + page + '&size=' + size)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getFareSsrList(){
            return $http.get(urlBase + '/list?detailed=true')
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getFareItem(id){
            return $http.get(urlBase + "/" + id )
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('fareItems')
                });
        }

        function getFareSsrByItemId(id){
            return $http.get(urlBase + '/list/'+id+'/item')
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function saveFareItem(fareItem){
            return $http.post(urlBase, fareItem)
                .then(function(response){
                    messageService.register('items');
                    return response;
                })
                .catch(function(){
                    messageService.registerError('items')
                });
        }

        function updateFareItem(fareItemId, fareItem){
            return $http.put(urlBase + "/" + fareItemId, fareItem)
                .then(function(response){
                    messageService.registerUpdate('items')
                    return response;
                })
                .catch(function(){
                    messageService.registerUpdateError('items')
                });
        }

        function deleteFareItem(fareItemId){
            return $http.delete(urlBase + "/" + fareItemId)
                .then(function(response){
                    messageService.registerDelete('items');
                    return response;
                })
                .catch(function(){
                    messageService.registerDeleteError('items');
                });
        }
    }
})();
